import React from 'react';

const DatabaseNotFound: React.FC = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
      margin: '0px 50px',
    }}
  >
    <div className='hit-title'>Database not found</div>
  </div>
);

export default DatabaseNotFound;
